import Grid from '@material-ui/core/Grid';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React from 'react';

const ExpirationDaysCapaInicial = () => (
  <Grid container spacing={2}>
    <Grid item md={3} xs={12}>
      <Field
        name="expirationDaysCapaInicial"
        component={TextField}
        fullWidth
        required
        variant="outlined"
        size={'small'}
      />
    </Grid>
  </Grid>
);

export default ExpirationDaysCapaInicial;
